import React from "react";
import "./field-information-title-bar.css";
import { LockIcon } from "~/core/icons";

interface IProps {
    className?: string;
    fieldName: string;
    customerName: string;
    farmName: string;
    acres: number;
    lockBoundary: boolean;
}

export const FieldInformationTitleBar = (props: IProps): JSX.Element => {
    /// ----------------------------------------- ///

    /// Event Handlers ///

    /// ------------- ///

    const { fieldName, customerName, farmName, acres, lockBoundary } = props;
    const farmNameVisible = farmName !== "" && farmName != null;

    return (
        <div className="field-information-title-bar title-bar">
            <div className="first-line">{fieldName}</div>
            <div className="second-line">{customerName}</div>
            <div className="third-line">
                {farmNameVisible && <span>{farmName}, </span>}
                <span>{acres.toFixed(2)} acres</span>{" "}
                {lockBoundary ? <LockIcon className="lock-icon" /> : null}
            </div>
        </div>
    );
};
FieldInformationTitleBar.defaultProps = {
    fieldName: "",
    customerName: "",
    farmName: "",
    acres: 0,
};
